class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.style.paddingRight = '';
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// js for shipping-bar-drawer

const GWP_TRIGGER_VARIANT_ID = 47512107417939;
const GWP_FREE_VARIANT_ID    = 53678542487891;
const GWP_PAID_VARIANT_ID    = 53678542520659;
const GWP_TRIGGER_QTY        = 4;

function updateShippingBar(cart) {
  const container = document.querySelector('#ShippingBarDrawer');
  if (!container || !cart) return;

  const config = JSON.parse(container.dataset.config);
  const excludedQty = (cart.items || [])
    .filter(i => i.variant_id === GWP_PAID_VARIANT_ID || i.variant_id === GWP_FREE_VARIANT_ID)
    .reduce((sum, i) => sum + i.quantity, 0);
  const count = Math.max(0, (cart.item_count || 0) - excludedQty);
  
  const msgEl = container.querySelector('[data-sb-msg]');
  const progressEl = container.querySelector('[data-sb-progress]');
  const noteEl = container.querySelector('[data-sb-note]');
  const simplePriceElements = document.querySelectorAll('[data-shipping-price-simple]');

  container.classList.toggle('shipping-bar--hidden', count === 0);
  if (count === 0) return;

  const isSuccess = count >= config.threshold;
  const percent = Math.min((count / config.threshold) * 100, 100);

  const drawer = document.querySelector('cart-drawer');
  if (drawer) drawer.classList.toggle('is-success', isSuccess);

  container.classList.toggle('shipping-bar--success', isSuccess);
  progressEl.classList.toggle('progress-bar--success', isSuccess);
  noteEl.classList.toggle('shipping-bar-note--hidden', isSuccess);

  requestAnimationFrame(() => {
    progressEl.style.width = `${percent}%`;
  });

  if (isSuccess) {
    const msg = container.dataset.msgSuccess;
    msgEl.textContent = msg;
    simplePriceElements.forEach(el => el.textContent = msg);
  } else {
    const remaining = config.threshold - count;
    const plural = remaining === 1 ? "" : "s";
    msgEl.textContent = `${container.dataset.msgProgress1} ${remaining} Ravecap${plural} ${container.dataset.msgProgress2}`;
    const formattedCost = config.costs[count] || config.costs["1"] || "";
    noteEl.textContent = `${container.dataset.msgCost}\u00A0\u00A0${formattedCost} (${container.dataset.country})`;
    simplePriceElements.forEach(el => el.textContent = formattedCost);
  }
}

let gwpTimer   = null;
let gwpRunning = false;

function scheduleGWPCheck() {
  clearTimeout(gwpTimer);
  gwpTimer = setTimeout(runGWPCheck, 400);
}

async function runGWPCheck() {
  if (gwpRunning) return;
  gwpRunning = true;
  try {
    const cart        = await fetch(`${window.Shopify.routes.root}cart.js`).then(r => r.json());
    const triggerItem = cart.items.find(i => i.variant_id === GWP_TRIGGER_VARIANT_ID);
    const freeItem    = cart.items.find(i => i.variant_id === GWP_FREE_VARIANT_ID);
    const paidFanItem = cart.items.find(i => i.variant_id === GWP_PAID_VARIANT_ID);
    const qualifies   = triggerItem && triggerItem.quantity >= GWP_TRIGGER_QTY;

    if (qualifies && !freeItem) {
      if (paidFanItem) {
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: paidFanItem.key, quantity: 0 }),
        });
      }
      
      await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: GWP_FREE_VARIANT_ID, quantity: 1 }] }),
      });
      document.querySelector('cart-drawer-items')?.onCartUpdate();
      document.querySelector('cart-items')?.onCartUpdate();

    } else if (!qualifies && (freeItem || (paidFanItem && !triggerItem))) {
      const noTriggerItems = !triggerItem;
      const cartWillBeEmpty = cart.items.filter(i => {
        if (i.variant_id === GWP_FREE_VARIANT_ID) return false;
        if (noTriggerItems && i.variant_id === GWP_PAID_VARIANT_ID) return false;
        return true;
      }).length === 0;

      if (freeItem) {
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: freeItem.key, quantity: 0 }),
        });
      }

      if (paidFanItem && noTriggerItems) {
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: paidFanItem.key, quantity: 0 }),
        });
      }

      if (cartWillBeEmpty) {
        fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`)
          .then(r => r.json())
          .then(sections => {
            const drawerDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            const newInner = drawerDoc.querySelector('.drawer__inner');
            const currentInner = document.querySelector('.drawer__inner');
            if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
            document.querySelector('cart-drawer')?.classList.add('is-empty');

            const iconDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            const newIcon = iconDoc.querySelector('.shopify-section');
            const currentIcon = document.getElementById('cart-icon-bubble');
            if (newIcon && currentIcon) currentIcon.innerHTML = newIcon.innerHTML;
          });
      } else {
        document.querySelector('cart-drawer-items')?.onCartUpdate();
        document.querySelector('cart-items')?.onCartUpdate();
      }
    }
  } catch (e) {
    console.warn('[GWP]', e);
  } finally {
    gwpRunning = false;
  }
}

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    updateShippingBar(event.cartData);
    scheduleGWPCheck();
  });
}

const originalFetch = window.fetch;
window.fetch = function () {
  return originalFetch.apply(this, arguments).then((response) => {
    const url = response.url || '';
    if (url.includes('/cart/add') || url.includes('/cart/change')) {
      response.clone().json().then(() => {
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then(res => res.json())
          .then(cart => updateShippingBar(cart));
      }).catch(() => {});
    }
    return response;
  });
};

document.addEventListener('DOMContentLoaded', () => {
  fetch(`${window.Shopify.routes.root}cart.js`)
    .then(res => res.json())
    .then(cart => {
      updateShippingBar(cart);
      scheduleGWPCheck();
    });
});

// Upsell add-to-cart
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-upsell-variant]');
  if (!btn) return;
  const variantId = parseInt(btn.dataset.upsellVariant);
  btn.disabled = true;
  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then(r => r.json())
    .then(() => document.querySelector('cart-drawer-items')?.onCartUpdate())
    .catch(console.warn)
    .finally(() => { btn.disabled = false; });
});